export const UI_SET_LOADER = 'UI_SET_LOADER';
export const UI_SET_LOADER_TEXT = 'UI_SET_LOADER_TEXT';
export const SET_UI_PROPERTY = 'SET_UI_PROPERTY';
export const SET_PARTNER_DATA = 'SET_PARTNER_DATA';
export const GET_MARKDOWN_FILE = 'GET_MARKDOWN_FILE';
export const GET_PARTNER_DATA = 'GET_PARTNER_DATA';

// New UI
export const UI_SET_VEHICLE_MODELS = 'UI_SET_VEHICLE_MODELS';
export const UI_SET_VEHICLE_MARKS = 'UI_SET_VEHICLE_MARKS';
export const UI_SET_VEHICLE_STYLE_BODY = 'UI_SET_VEHICLE_STYLE_BODY';
export const UI_GET_VEHICLE_MARKS = 'UI_GET_VEHICLE_MARKS';
export const UI_GET_VEHICLE_MODELS = 'UI_GET_VEHICLE_MODELS';
export const UI_GET_VEHICLE_STYLE_BODY = 'UI_GET_VEHICLE_STYLE_BODY';
export const UI_RESET_VEHICLE_MODELS = 'UI_RESET_VEHICLE_MODELS';
export const UI_RESET_VEHICLE_BODY_STYLES = 'UI_RESET_VEHICLE_BODY_STYLES';
